// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"9fc7cdbb9911adcf104f","691":"5f98b117a506df94cd72"}[chunkId] + ".js";
};